import React, { Component } from 'react'
import Slider from '../../logicTwo/panels/helpers/Slider'
import { Link } from 'react-router-dom'

import { timericon } from '../../../source/index'
import renderPrgImage from '../../../source/programImg'
import PanelHighlightContext, {
    isKeyHighlighted,
} from '../PanelHighlightContext'

var h = 0
var m = 0
var s = 0
var ms = 0

var _0to60 = {},
    _0to24 = {},
    _0to1000 = {}
for (let i = 0; i < 24; i++) _0to24[i] = i
for (let i = 0; i < 60; i++) _0to60[i] = i
for (let i = 0; i < 1000; i += 50) _0to1000[i] = i
class WaitPanel extends Component {
    static contextType = PanelHighlightContext

    constructor(props) {
        super(props)
        this.state = { value: 0 }
    }

    onChange = (key, value) => {
        const { state, onChange } = this.props
        
        // Create a new object to avoid mutating the original reference
        const newState = { ...state, [key]: value }

        switch (key) {
            case 'h': {
                h = value
                break
            }
            case 'm': {
                m = value
                break
            }
            case 's': {
                s = value
                break
            }
            case 'ms': {
                ms = value
                break
            }
        }

        // Pass the new object up to the parent
        onChange(newState, 'wait')
    }

    hexTypeCheck = () => {
        const { state, onChange } = this.props
        // state[key] = value;
        onChange(state, 'wait')
        // this.props.hexTypeCheck("wait")
    }
    componentDidUpdate(prevProps) {
        if (prevProps.state !== this.props.state) {
            // console.log("waitvalueIN", prevProps.state, this.props.state);
            // return this.render
        }
    }

    render() {
        const min = this.props.min || 0
        const max = this.props.max || 255
        const { name, assign, value, port, state, onChange } = this.props
        // const isRoboki = sessionStorage.getItem('connectedDevice') === 'Roboki'
        const isToki = sessionStorage.getItem('connectedDevice') === 'Toki'

        var timeDelays = ['Milliseconds', 'Seconds', 'Minutes', 'Hours']
        const getValue = () => {
            return state['ms'] || 0
        }
        const _hlInfo = this.context
        const _hlMs = isKeyHighlighted(_hlInfo, 'ms')
            ? ' highlight-panel-slider'
            : ''
        const _hlS = isKeyHighlighted(_hlInfo, 's')
            ? ' highlight-panel-slider'
            : ''
        const _hlM = isKeyHighlighted(_hlInfo, 'm')
            ? ' highlight-panel-slider'
            : ''
        const _hlH = isKeyHighlighted(_hlInfo, 'h')
            ? ' highlight-panel-slider'
            : ''


        // Tutorial locking: disable non-highlighted sliders/checkboxes
        const tutorialLocked = !!_hlInfo?.tutorialLocked

        const isMsLocked = tutorialLocked && !isKeyHighlighted(_hlInfo, 'ms')
        const isSLocked = tutorialLocked && !isKeyHighlighted(_hlInfo, 's')
        const isMLocked = tutorialLocked && !isKeyHighlighted(_hlInfo, 'm')
        const isHLocked = tutorialLocked && !isKeyHighlighted(_hlInfo, 'h')

        // Tutorial locking: disable non-highlighted sliders
        const lockedMsStyle =
            tutorialLocked && !_hlMs
                ? { pointerEvents: 'none', opacity: 0.35 }
                : {}
        const lockedSStyle =
            tutorialLocked && !_hlS
                ? { pointerEvents: 'none', opacity: 0.35 }
                : {}
        const lockedMStyle =
            tutorialLocked && !_hlM
                ? { pointerEvents: 'none', opacity: 0.35 }
                : {}
        const lockedHStyle =
            tutorialLocked && !_hlH
                ? { pointerEvents: 'none', opacity: 0.35 }
                : {}

        return (
            <div className="Wait-main-container">
                <div
                    className="slider-section"
                    // style={{ border: '2px solid red' }}
                >
                    <div
                        className={`slider-item1${_hlMs}`}
                        style={{
                            position: 'relative',
                            // border: '2px solid yellow',
                            ...lockedMsStyle,
                        }}
                    >
                        <Slider
                            title="Milliseconds"
                            name="milliseconds"
                            options={_0to1000}
                            value={getValue()}
                            min={0}
                            max={999}
                            disabled={isMsLocked}
                            renderIn="waitPropertyPanel"
                            onChange={(value) => this.onChange('ms', value)}
                        />

                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',
                                left: '28%',
                                fontSize: '16px',
                            }}
                        >
                            {0}
                        </p>
                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                fontSize: '16px',
                                right: '24%',
                            }}
                        >
                            999
                        </p>
                    </div>
                    <div
                        className={`slider-item1${_hlS}`}
                        style={{ position: 'relative', ...lockedSStyle }}
                    >
                        <Slider
                            title="Seconds"
                            name="seconds"
                            value={state['s'] || 0}
                            options={_0to60}
                            min={0}
                            max={59}
                            renderIn="waitPropertyPanel"
                            onChange={(value) => this.onChange('s', value)}
                            disabled={isSLocked}
                        />

                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                left: '28%',
                                fontSize: '16px',
                            }}
                        >
                            0
                        </p>
                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                fontSize: '16px',
                                right: '24%',
                            }}
                        >
                            59
                        </p>
                    </div>

                    <div
                        className={`slider-item1${_hlM}`}
                        style={{ position: 'relative', ...lockedMStyle }}
                    >
                        <Slider
                            title="Minutes"
                            name="minutes"
                            value={state['m'] || 0}
                            options={_0to60}
                            min={0}
                            max={59}
                            renderIn="waitPropertyPanel"
                            onChange={(value) => this.onChange('m', value)}
                            disabled={isMLocked}
                        />

                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                left: '28%',
                                fontSize: '16px',
                            }}
                        >
                            0
                        </p>
                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                fontSize: '16px',
                                right: '24%',
                            }}
                        >
                            59
                        </p>
                    </div>

                    <div
                        className={`slider-item1${_hlH}`}
                        style={{ position: 'relative', ...lockedHStyle }}
                    >
                        <Slider
                            title="Hours"
                            name="hours"
                            value={state['h'] || 0}
                            options={_0to24}
                            max={23}
                            min={0}
                            renderIn="waitPropertyPanel"
                            onChange={(value) => this.onChange('h', value)}
                            disabled={isHLocked}
                        />

                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                left: '28%',
                                fontSize: '16px',
                            }}
                        >
                            0
                        </p>
                        <p
                            style={{
                                position: 'absolute',
                                top: '67%',

                                fontSize: '16px',
                                right: '24%',
                            }}
                        >
                            23
                        </p>
                    </div>
                </div>

                <div className="timer-section">
                    <img
                        src={renderPrgImage('timericon')}
                        style={{ width: '22vh' }}
                    />
                    <div
                        style={{
                            height: '10%',
                            width: '53%',
                            border: '0.5px solid #25245E',
                            borderRadius: '5px',
                            position: 'relative',
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%,-50%)',
                            }}
                        >
                            <p style={{ marginBottom: '0' }}>
                                {/* {h}:{m}:{s}:{ms} */}
                                {state['h'] || 0}:{state['m'] || 0}:{state['s'] || 0}:{state['ms'] || 0}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default WaitPanel
/*<tr>
<td><Select options={_0to24} onChange={(value)=>this.onChange('h',value)} color={HexTypes['wait'].color} selected={h || 0}/> Hours</td>
<td><Select options={_0to60} onChange={(value)=>this.onChange('m',value)} color={HexTypes['wait'].color} selected={m || 0}/> Minutes</td>
<td><Select options={_0to60} onChange={(value)=>this.onChange('s',value)} color={HexTypes['wait'].color} selected={s || 0}/> Seconds</td>
<td><Select options={_0to1000} onChange={(value)=>this.onChange('ms',value)} color={HexTypes['wait'].color} selected={ms || 0}/> Milliseconds</td>
</tr>*/
